import request from "@/common/request.js";

export function listUser(data) {
  return request({
    url: "/system/user/list",
    method: "post",
    params: data,
  });
}
